/* eslint-disable import/prefer-default-export */
import { getConfig } from "@engaging-tech/ssr-config"
import { apollo } from "../../../lib/Apollo"
import { LOAD } from "./cms.queries"

const GRAPHQL_API_URL = () =>
  `${getConfig().api.url}${getConfig().api.endpoints.graphql}`

export const loadCMS = payload =>
  apollo.query({
    uri: GRAPHQL_API_URL,
    variables: { type: payload },
    query: LOAD
  })
